const DEFAULT_API_BASE = "http://localhost:3001/api";
const PROD_APP_HOSTS = new Set([
  "qubiq.tv",
  "www.qubiq.tv",
  "qubiq.games",
  "www.qubiq.games",
]);

const getConfiguredApiBase = () => String(process.env.REACT_APP_API_BASE || DEFAULT_API_BASE).trim();

const shouldUseRelativeApiBase = (configuredBase) => {
  if (typeof window === "undefined" || !window.location?.origin) return false;

  try {
    const targetUrl = new URL(configuredBase, window.location.origin);
    const currentHost = String(window.location.hostname || "").toLowerCase();
    const targetHost = String(targetUrl.hostname || "").toLowerCase();
    return PROD_APP_HOSTS.has(currentHost) && PROD_APP_HOSTS.has(targetHost);
  } catch {
    return false;
  }
};

export const getApiBase = ({ trailingSlash = false } = {}) => {
  const configuredBase = getConfiguredApiBase();

  if (shouldUseRelativeApiBase(configuredBase)) {
    return trailingSlash ? "/api/" : "/api";
  }

  try {
    const resolvedBase =
      typeof window !== "undefined" && window.location?.origin
        ? new URL(configuredBase, window.location.origin)
        : new URL(configuredBase);
    const normalizedPath = resolvedBase.pathname.replace(/\/+$/, "");
    const pathname = normalizedPath.endsWith("/api") ? normalizedPath : `${normalizedPath}/api`;
    return trailingSlash
      ? `${resolvedBase.origin}${pathname}/`
      : `${resolvedBase.origin}${pathname}`;
  } catch {
    const normalizedBase = configuredBase.replace(/\/+$/, "");
    const apiBase = normalizedBase.endsWith("/api") ? normalizedBase : `${normalizedBase}/api`;
    return trailingSlash ? `${apiBase}/` : apiBase;
  }
};

export const resolveApiAssetUrl = (value) => {
  const rawValue = String(value || "").trim();
  if (!rawValue) return "";
  if (/^https?:\/\//i.test(rawValue) || rawValue.startsWith("data:") || rawValue.startsWith("blob:")) {
    return rawValue;
  }

  const apiBase = getApiBase();
  try {
    const apiUrl = new URL(apiBase, typeof window !== "undefined" ? window.location.origin : undefined);
    return new URL(rawValue, `${apiUrl.origin}/`).toString();
  } catch {
    return rawValue;
  }
};
